import { put, takeLeading, throttle } from 'redux-saga/effects';

import HospitalAPI from 'lib/api/HospitalAPI';
import createRequestSaga from 'store/helpers/createRequestSaga';
import { openSnackbar } from 'features/snackbar';
import {
  GET_NOT_ASSIGNED_RESERVATION_LIST,
  GET_NOT_PAID_RESERVATION_LIST,
  GET_RESERVATION_LIST,
  GET_TODAY_RESERVATION_LIST,
  GET_WEEKLY_RESERVATION_LIST,
  GET_PATIENT_RESERVATION_LIST,
  CHECK_RESERVATIONS,
  CREATE_RESERVATION,
  UPDATE_RESERVATION,
  DELETE_RESERVATION,
} from '.';

const getReservationListSaga = createRequestSaga(
  GET_RESERVATION_LIST,
  HospitalAPI.getReservationList,
);
const getTodayReservationListSaga = createRequestSaga(
  GET_TODAY_RESERVATION_LIST,
  HospitalAPI.getReservationList,
);
const getWeeklyReservationListSaga = createRequestSaga(
  GET_WEEKLY_RESERVATION_LIST,
  HospitalAPI.getReservationList,
);
const getNotPaidReservationListSaga = createRequestSaga(
  GET_NOT_PAID_RESERVATION_LIST,
  HospitalAPI.getReservationList,
);
const getPatientReservationListSaga = createRequestSaga(
  GET_PATIENT_RESERVATION_LIST,
  HospitalAPI.getReservationList,
);
const getNotAssignedReservationListSaga = createRequestSaga(
  GET_NOT_ASSIGNED_RESERVATION_LIST,
  HospitalAPI.getReservationList,
);
const checkReservationsSaga = createRequestSaga(
  CHECK_RESERVATIONS,
  HospitalAPI.checkReservations,
);
const createReservationSaga = createRequestSaga(
  CREATE_RESERVATION,
  HospitalAPI.createReservation,
  function* () {
    yield put(openSnackbar('예약이 생성되었습니다'));
  },
);
const updateReservationSaga = createRequestSaga(
  UPDATE_RESERVATION,
  HospitalAPI.updateReservation,
  function* () {
    yield put(openSnackbar('수정되었습니다'));
  },
);
const deleteReservationSaga = createRequestSaga(
  DELETE_RESERVATION,
  HospitalAPI.deleteReservation,
);

export default function* paymentsSaga() {
  yield throttle(1000, GET_RESERVATION_LIST, getReservationListSaga);
  yield throttle(1000, GET_TODAY_RESERVATION_LIST, getTodayReservationListSaga);
  yield throttle(
    1000,
    GET_WEEKLY_RESERVATION_LIST,
    getWeeklyReservationListSaga,
  );
  yield throttle(
    1000,
    GET_NOT_PAID_RESERVATION_LIST,
    getNotPaidReservationListSaga,
  );
  yield throttle(
    1000,
    GET_NOT_ASSIGNED_RESERVATION_LIST,
    getNotAssignedReservationListSaga,
  );
  yield throttle(
    1000,
    GET_PATIENT_RESERVATION_LIST,
    getPatientReservationListSaga,
  );
  yield throttle(1000, CHECK_RESERVATIONS, checkReservationsSaga);
  yield takeLeading(CREATE_RESERVATION, createReservationSaga);
  yield takeLeading(UPDATE_RESERVATION, updateReservationSaga);
  yield takeLeading(DELETE_RESERVATION, deleteReservationSaga);
}
